import { KundeavisApiResponse } from "@modules/editorial-content/api/getCampaignPaper"
import kundeavisImg from "../../../../explore-assets/kundeavis.jpg"
import apningstiderImg from "../../../../explore-assets/apningstider.jpg"

export type ContentBlockItem = {
    Sort: number
    Type: "ContentBlock"
    Content: {
        Title: string
        Image: string
        Link?: string | null
        LinkText?: string | null
        Text?: string | null
        Style?: string | null
    }
}

const KUNDEAVIS_BILDE_URL = kundeavisImg

const APNINGSTIDER_BILDE_URL = apningstiderImg

const FALLBACK_KUNDEAVIS_URL = "https://kundeavis.meny.no/"

const FINN_BUTIKK_URL = "https://meny.no/finn-butikk/"

export const buildEditorialContent = (kundeavis: KundeavisApiResponse): ContentBlockItem[] => {
    const kundeavisUrl = kundeavis?.nation?.url ?? FALLBACK_KUNDEAVIS_URL
    return [
        {
            Sort: 1,
            Type: "ContentBlock",
            Content: {
                Title: "Kundeavis",
                Image: KUNDEAVIS_BILDE_URL,
                Link: `${kundeavisUrl}`,
                LinkText: null,
                Text: null,
                Style: "inspiration",
            },
        },
        {
            Sort: 2,
            Type: "ContentBlock",
            Content: {
                Title: "Åpningstider",
                Image: APNINGSTIDER_BILDE_URL,
                Link: FINN_BUTIKK_URL,
                LinkText: null,
                Text: null,
                Style: "inspiration",
            },
        },
    ]
}
